import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * NavigationApiService (Angular 18) — reads the versioned navigation JSON
 * shipped as a static asset.
 *
 * Replaces apps/b2b-ui/common/services/api/navigationApi/navigationApi.service.js.
 *
 * The legacy service nested the method under `.config.detail()`; consumers
 * call `apiService.navigation.config.detail(version)`. We preserve that shape
 * 1:1 so the facade contract stays drop-in.
 */
@Injectable({ providedIn: "root" })
export class NavigationApiService {
  private readonly http = inject(HttpClient);

  readonly config = {
    detail: (version: string): Promise<AjsResponse<unknown>> =>
      wrapAjs(
        this.http.get<unknown>(`/assets/data/navigation/${version}.json`),
      ),
  };
}
